import { useEffect } from "react"
import { Calendar, dateFnsLocalizer, Views } from "react-big-calendar"
import "./daily-calendar-styles.css"
import DailyCaledarCustomEvent from "./daily-calendar-custom-event"
import config from "@/modules/calendar/config/calendar-config"
import { setHours, setMinutes, setSeconds } from "date-fns"
import { useDailyCalendarEvents } from "../../stores/use-daily-calendar-events"
import getCustomEvents from "../../utils/get-custom-events"
import getEventsWithExceededActivitiesAlert from "../../utils/get-events-with-exceeded-activities-alert"

const localizer = dateFnsLocalizer(config)

interface DailyCalendarProps {
  onClickActivitiesExceeded: () => void
}

export default function DailyCalendar({ onClickActivitiesExceeded }: DailyCalendarProps) {
  const { filteredEvents } = useDailyCalendarEvents()
  const today = new Date()
  const minTime = setSeconds(setMinutes(setHours(today, 0), 0), 0)
  const maxTime = setSeconds(setMinutes(setHours(today, 23), 30), 0)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const currentTimeIndicator = document.querySelector(".rbc-current-time-indicator")
      if (!currentTimeIndicator) return

      const rect = currentTimeIndicator.getBoundingClientRect()
      const scrollPosition = window.scrollY + rect.top - 150 // Subtract 150px to give space at the top.
      window.scrollTo({ top: scrollPosition, behavior: "smooth" })
    }, 300)

    return () => clearTimeout(timeoutId)
  }, [])

  const customEvents = getCustomEvents(filteredEvents)
  const eventsWithExceededActivitiesAlert = getEventsWithExceededActivitiesAlert(customEvents)

  const events = eventsWithExceededActivitiesAlert.filter(
    (ev) => !(ev.dailyCalendarEventType === "event" && ev.parent.category === "study_time"),
  )

  return (
    <div className="daily-calendar-container h-auto p-0">
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        defaultView={Views.DAY}
        views={[Views.DAY]}
        defaultDate={today}
        min={minTime} // TO DO: This MUST BE same time of "Mi agenda".
        max={maxTime} // TO DO: This MUST BE same time of "Mi agenda".
        step={15}
        timeslots={4}
        components={{
          event: ({ event }) => (
            <DailyCaledarCustomEvent
              event={event}
              onClickActivitiesExceeded={onClickActivitiesExceeded}
            />
          ),
          toolbar: () => null,
          timeGutterHeader: () => null,
        }}
        dayLayoutAlgorithm="no-overlap"
        popup={true}
      />
    </div>
  )
}
